import { PACKAGE_STATUS } from '@/constants/status';

export const SIDEBAR_MENU_ITEMS = [
    {
        labelTranslationKey: 'sidebar.menu_dashboard',
        link: {
            name: 'dashboard',
        },
        icon: {
            active: require('@/assets/images/icons/active/home.svg'),
            inactive: require('@/assets/images/icons/inactive/home.svg'),
        },
    },
    {
        labelTranslationKey: 'sidebar.menu_domain',
        link: {
            name: 'domain.list',
            query: {
                state: PACKAGE_STATUS.ACTIVE.key,
            },
        },
        icon: {
            active: require('@/assets/images/icons/active/domain.svg'),
            inactive: require('@/assets/images/icons/inactive/domain.svg'),
        },
    },
    {
        labelTranslationKey: 'sidebar.menu_ssl',
        link: {
            name: 'ssl.list',
            query: {
                status: PACKAGE_STATUS.ACTIVE.key,
            },
        },
        icon: {
            active: require('@/assets/images/icons/active/ssl.svg'),
            inactive: require('@/assets/images/icons/inactive/ssl.svg'),
        },
    },
    {
        labelTranslationKey: 'sidebar.menu_cloud_server',
        link: {
            name: 'cloud-server.list',
            query: {
                status: PACKAGE_STATUS.ACTIVE.key,
            },
        },
        icon: {
            active: require('@/assets/images/icons/active/cloud-server.svg'),
            inactive: require('@/assets/images/icons/inactive/cloud-server.svg'),
        },
    },
    {
        labelTranslationKey: 'sidebar.menu_cloud_hosting',
        link: {
            name: 'cloud-hosting.list',
            query: {
                status: PACKAGE_STATUS.ACTIVE.key,
            },
        },
        icon: {
            active: require('@/assets/images/icons/active/cloud-hosting.svg'),
            inactive: require('@/assets/images/icons/inactive/cloud-hosting.svg'),
        },
    },
    {
        labelTranslationKey: 'sidebar.menu_shared_hosting',
        link: {
            name: 'shared-hosting.list',
            query: {
                status: PACKAGE_STATUS.ACTIVE.key,
            },
        },
        icon: {
            active: require('@/assets/images/icons/active/shared-hosting.svg'),
            inactive: require('@/assets/images/icons/inactive/shared-hosting.svg'),
        },
    },
    {
        labelTranslationKey: 'sidebar.menu_wp_hosting',
        link: {
            name: 'wp-hosting.list',
            query: {
                status: PACKAGE_STATUS.ACTIVE.key,
            },
        },
        icon: {
            active: require('@/assets/images/icons/active/wp-hosting.svg'),
            inactive: require('@/assets/images/icons/inactive/wp-hosting.svg'),
        },
    },
    {
        labelTranslationKey: 'sidebar.menu_sms',
        link: {
            name: 'sms.management',
        },
        icon: {
            active: require('@/assets/images/icons/active/sms.svg'),
            inactive: require('@/assets/images/icons/inactive/sms.svg'),
        },
    },
    {
        labelTranslationKey: 'sidebar.menu_aws',
        link: {
            name: 'aws.accounts',
        },
        icon: {
            active: require('@/assets/images/icons/active/aws.svg'),
            inactive: require('@/assets/images/icons/inactive/aws.svg'),
        },
    },
    {
        labelTranslationKey: 'sidebar.menu_api',
        link: {
            name: 'api',
        },
        icon: {
            active: require('@/assets/images/icons/active/api.svg'),
            inactive: require('@/assets/images/icons/inactive/api.svg'),
        },
    },
    {
        labelTranslationKey: 'sidebar.menu_invoice',
        link: {
            name: 'invoices.list',
        },
        icon: {
            active: require('@/assets/images/icons/active/invoice.svg'),
            inactive: require('@/assets/images/icons/inactive/invoice.svg'),
        },
    },
    {
        labelTranslationKey: 'sidebar.menu_wallet',
        link: {
            name: 'wallet.payments',
        },
        icon: {
            active: require('@/assets/images/icons/active/payment.svg'),
            inactive: require('@/assets/images/icons/inactive/payment.svg'),
        },
    },
    {
        labelTranslationKey: 'sidebar.menu_profile',
        link: {
            name: 'profile',
        },
        icon: {
            active: require('@/assets/images/icons/active/user.svg'),
            inactive: require('@/assets/images/icons/inactive/user.svg'),
        },
    },
    {
        labelTranslationKey: 'sidebar.menu_loyalty_program',
        link: {
            name: 'loyalty-program',
        },
        icon: {
            active: require('@/assets/images/icons/active/loyalty.svg'),
            inactive: require('@/assets/images/icons/inactive/loyalty.svg'),
        },
    },
    {
        labelTranslationKey: 'sidebar.menu_promo_credit',
        link: {
            name: 'promo-credit',
        },
        icon: {
            active: require('@/assets/images/icons/active/promo-credit.svg'),
            inactive: require('@/assets/images/icons/inactive/promo-credit.svg'),
        },
    },
    {
        labelTranslationKey: 'sidebar.menu_affiliate',
        link: {
            name: 'affiliate',
        },
        icon: {
            active: require('@/assets/images/icons/active/affiliate.svg'),
            inactive: require('@/assets/images/icons/inactive/affiliate.svg'),
        },
    },
];
